import $ from 'jquery'

var projecthover = function() {

    var windowWidth = null;

    function imgHover() {

        $('.parts-archive .project-wrap').on('mouseout', function() {

          if ($(window).width() > 800) {
            $(this).addClass('mouseout');
            $(this).find('.thumb-info').addClass('mouseout');
          }

        });

        $('.team .project-wrap').on('mouseout', function() {

          if ($(window).width() > 800) {
            $(this).addClass('mouseout');
            $(this).find('.thumb-info').addClass('mouseout');
          }

        });
    }

    imgHover();

    $(window).on('resize', function() {

      setTimeout(function() {
        $('.project-wrap').removeClass('mouseout');
        $('.info').removeClass('mouseout');

        imgHover();
      }, 250);

    });


}

module.exports = projecthover;



// WEBPACK FOOTER //
// ./resources/assets/js/modules/project-hover.js